// Mixins
import AppPage from '../../mixins/app-page'

// Components
import AppScrollObject from '../app-scroll-object'

// Utils
import { getSafe } from '../../utils/Object'

export default
{
    name: 'page-chef',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppScrollObject
    },

    data()
    {
        return {
            mediasLoaded: 0
        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.page.acf
        },

        numberOfMedias()
        {
            let n = 0

            for (let i = 0; i < this.content.blocks.length; i += 1)
            {
                n += this.content.blocks[i].images.length
            }

            return n
        },

        images()
        {
            const images = []

            for (let i = 0; i < this.content.blocks.length; i += 1)
            {
                if (getSafe(() => this.content.blocks[i].images)
                && this.content.blocks[i].images.length > 0)
                {
                    for (let j = 0; j < this.content.blocks[i].images.length; j += 1)
                    {
                        images.push(this.content.blocks[i].images[j])
                    }
                }
            }

            return images
        },

        texts()
        {
            const texts = []

            for (let i = 0; i < this.content.blocks.length; i += 1)
            {
                if (getSafe(() => this.content.blocks[i].texts)
                && this.content.blocks[i].texts.length > 0)
                {
                    for (let j = 0; j < this.content.blocks[i].texts.length; j += 1)
                    {
                        texts.push(this.content.blocks[i].texts[j])
                    }
                }
            }

            return texts
        }
    },

    created()
    {
        console.log(this.texts)
        // Events
        this.eventHub.$on('window:resize', this._onResize)
    },

    mounted()
    {

    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // Events
        _onResize()
        {
            //
        },

        // HTML Actions
        _onLoadMedia()
        {
            this.mediasLoaded += 1

            if (this.mediasLoaded === this.numberOfMedias)
            {
                this.$nextTick(() =>
                {
                    this.$nextTick(() =>
                    {
                        this.eventHub.$emit('page:medias-loaded')
                    })
                })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-chef/script.js